/* The Upload place's drop card (ADR-0212). Every colour is a token (ADR-0007). */

.panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
}

.notice {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  padding: 2px 10px;
  border: 1px solid var(--warn-line);
  border-radius: var(--radius-pill);
  background: var(--warn-w);
  color: var(--warn);
  font-size: var(--t-dense);
  font-weight: 600;
}

.state {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: var(--ink-2);
}

.context {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 600;
}

.field select {
  min-width: 180px;
  height: var(--h-ctl);
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-weight: 500;
}

.fieldError {
  color: var(--crit);
  font-weight: 500;
}

.dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 18px 16px;
  border: 2px dashed var(--accent-line);
  border-radius: var(--radius-card);
  background: var(--accent-w);
}

.over {
  border-color: var(--accent);
  background: var(--panel-3);
}

.target {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.icon {
  color: var(--accent);
}

.title {
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 700;
}

/* The real input: reachable by keyboard and screen reader, drawn as a focus ring on the target. */
.pick {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.target:focus-within {
  outline: 2px solid var(--focus);
  outline-offset: 4px;
  border-radius: var(--radius-chip);
}

.types {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font-size: var(--t-min);
  font-weight: 600;
}

.chip[data-tone="warn"] {
  border-color: var(--warn-line);
  background: var(--warn-w);
  color: var(--warn);
}

/* The chip while the limit is still being read: the width of the sentence that will replace it. */
.chipBone {
  display: inline-block;
  width: 116px;
  height: 20px;
  border-radius: var(--radius-pill);
}

/* Try again, inside the chip that says the limit could not be read. */
.chipRetry {
  margin-left: 8px;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.progress {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ink-2);
  font-size: var(--t-dense);
}

.progress progress {
  width: 220px;
}

.alert {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid var(--warn-line);
  border-radius: var(--radius-chip);
  background: var(--warn-w);
}

.alert p {
  margin: 0;
  flex: 1 1 auto;
}

.error {
  margin: 0;
  color: var(--crit);
  font-weight: 600;
}

.action {
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.action:hover {
  background: var(--panel-2);
}
